<template>
    <section class="white_bg" id="contact">
        <div class="container">
            <div class="main_title mt_wave a_center" v-if="title!=null">
                <h2><span class="uppercase"> {{ title[currentLanguage] }} </span></h2>
            </div>
            <p class="main_description a_center" v-if="header!=null">{{ header[currentLanguage] }}</p>

            <div class="row">
                <div class="col-md-5">
                    <gmap-map
                            :center="center"
                            :zoom="16"
                            style="width: 100%; height: 380px"
                            :sensor="false"
                    >
                        <gmap-marker
                                :position="center"
                                :clickable="true"
                                :draggable="false"
                        ></gmap-marker>
                    </gmap-map>
                </div>
                <div class="col-md-7">
                    <div class="row">
                        <div class="contact-items">
                            <div class="col-md-3 col-sm-3">
                                <div class="contact-item">
                                    <i class="glyphicon glyphicon-map-marker"></i>
                                    <h6>{{ address }}</h6>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-4">
                                <div class="contact-item">
                                    <i class="glyphicon glyphicon-phone-alt"></i>
                                    <h6>{{ phone }}</h6>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-5">
                                <div class="contact-item">
                                    <i class="fa fa-envelope"></i>
                                    <h6>{{ email }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <contact-form></contact-form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Form from '../contactForm/Contact.vue';
    import config from '../../config/app';

    let lat = config.coordenate.lat, lng = config.coordenate.lng;
    export default {
        data(){
            return {
                center: {lat: config.coordenate.lat, lng: config.coordenate.lng},
                title : null,
                header : null,
                phone : null,
                email : null,
            }
        },
        created: function(){
            let self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
                if( !_.isNull(self.$store.getters.config) )
                {
                    self.title = self.$store.getters.config.contact.title;
                    self.header = self.$store.getters.config.contact.header;
                }
            });
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
                let latLng = val.contact.location;
                if (latLng && latLng.length && latLng.indexOf(',') !== -1) {
                    latLng = latLng.split(',');
                    if(!isNaN(latLng[0]) && !isNaN(latLng[1])){
                        lat = Number(latLng[0]);
                        lng = Number(latLng[1]);
                    }
                }
                self.center.lat = lat;
                self.center.lng = lng;
                self.phone = val.contact.phone;
                self.email = val.contact.email;
            });
        },
        beforeDestroy : function(){
            this.unsubscribe();
        },
        components : {
            'contact-form' : Form
        },
        computed : {
            address : function(){ return config.contact.address_small; },
            web : function(){ return config.contact.web; },
            fax : function(){ return config.contact.fax; },
            currentLanguage : function()
            {
                return this.$language;
            }
        },
        mounted : function()
        {
            let self = this;
            let config = this.$store.getters.config;
            if( !_.isNull(config) )
            {
                let latLng = config.contact.location;
                if (latLng && latLng.length && latLng.indexOf(',') !== -1){
                    latLng = latLng.split(',');
                    if(!isNaN(latLng[0]) && !isNaN(latLng[1])){
                        lat = Number(latLng[0]);
                        lng = Number(latLng[1]);
                    }
                }
                self.center.lat = lat;
                self.center.lng = lng;
                self.title = this.$store.getters.config.contact.title;
                self.header = this.$store.getters.config.contact.header;
            }
        }
    }
</script>

<style lang="scss">
    .uppercase
    {
        text-transform: uppercase;
    }
</style>


// WEBPACK FOOTER //
// ContactForm.vue?1e814574